import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useMilestoneProgressBarStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  progressWrapper: {
    position: 'relative',
  },
  progressBar: {
    '[role=progressbar]': {
      backgroundColor: tokens.colorNeutralBackground6,
    },
  },
  milestoneItem: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(-50%, -69%);',
  },
  milestoneDot: {
    width: tokens.spacingHorizontalL,
    height: tokens.spacingHorizontalL,
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border(tokens.strokeWidthThickest, 'solid', tokens.colorNeutralStencil1),
  },
  milestoneDotCompleted: {
    width: tokens.spacingHorizontalM,
    height: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorBrandBackground,
    ...shorthands.border(tokens.strokeWidthThickest, 'solid', tokens.colorBrandBackground),
  },

});
